import Vue from 'vue'
import VueRouter from 'vue-router'

import About from '../views/About.vue'
import Properties from '../views/Properties.vue'
import Investment from '../views/Investment.vue'
import Contact from '../views/Contact.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'GREA - Aassistant'
    }
  },
  { path: '/about',
   component: About,
   meta: {
    title: 'GREA - Aassistant'
  } },
  { path: '/properties',
   component: Properties,
   meta: {
    title: 'GREA - Aassistant'
  } },
  { path: '/investment', 
  component: Investment, 
  meta: {
    title: 'GREA - Aassistant'
  } },
  { path: '/contact', 
  component: Contact , 
  meta: {
    title: 'GREA - Aassistant'
  }}

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 添加滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title
  next()
})

export default router